import { wemogyTypes } from '@wemogy/reactbase';
import { types } from 'mobx-state-tree';
var ResourceSubjectPermission = types.model({
    resourceId: types.string,
    permissions: types.array(wemogyTypes.bits)
})
    .named('ResourceSubjectPermission');
export default ResourceSubjectPermission;
//# sourceMappingURL=ResourceSubjectPermission.js.map